export default {
  namespaced: true,
  state: {
    costToEdit: {},
    costNumber: '',
    costFilters: {},
    tempCostList: [],
  },
  getters: {
    getCostToEdit: state => state.costToEdit,
    getCostNumber: state => state.costNumber,
    getCostFilter: state => state.costFilter,
    getTempCostList: state => state.tempCostList,
  },
  mutations: {
    setCostToEdit (state, costToEdit) {
      state.costToEdit = costToEdit;
    },
    setCostNumber (state, costNumber) {
      state.costNumber = costNumber;
    },
    setCostFilter (state, costFilter) {
      state.costFilter = costFilter;
    },
    setTempCostList (state, costList) {
      state.tempCostList = costList;
    },
  },
  actions: {
  }
};
